/**
 * Admin Logs Routes
 */

const adminLogs = r => require.ensure([], () => r(require('./components/index')), 'adminlogs');

export default [
  {
    name: 'adminLogs',
    path: '/admin-logs',
    component: adminLogs,
    meta: {
      requiresAuth: true
    }
  }
];




// WEBPACK FOOTER //
// ./src/app/adminlogs/routes.js